var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a = require('./tokens'), smsTokenTypes = _a.smsTokenTypes, smsTokenMap = _a.smsTokenMap;
import { Parser } from 'chevrotain';
import { StardogSparqlParser } from '../sparql';
var SmsParser = /** @class */ (function (_super) {
    __extends(SmsParser, _super);
    function SmsParser(config) {
        var _this = _super.call(this, __assign({ outputCst: true, recoveryEnabled: true }, config), smsTokenTypes, true) || this;
        _this.parse = function (document) {
            _this.input = _this.tokenize(document);
            var cst = _this.MappingDoc();
            var errors = _this.errors;
            return {
                errors: errors,
                cst: cst,
            };
        };
        _this.MappingDoc = _this.RULE('MappingDoc', function () {
            _this.MANY(function () { return _this.SUBRULE(_this.PrefixDecl); });
            _this.OPTION(function () {
                _this.SUBRULE(_this.MappingClause);
                _this.MANY1(function () {
                    _this.CONSUME(smsTokenMap.Semicolon);
                    _this.SUBRULE1(_this.MappingClause);
                });
            });
        });
        _this.MappingClause = _this.RULE('MappingClause', function () {
            _this.SUBRULE(_this.MappingDecl);
            _this.SUBRULE(_this.FromClause);
            _this.SUBRULE(_this.ToClause);
            _this.SUBRULE(_this.WhereClause);
        });
        _this.MappingDecl = _this.RULE('MappingDecl', function () {
            _this.CONSUME(smsTokenMap.Mapping);
            _this.OPTION(function () { return _this.SUBRULE(_this.iri); });
        });
        _this.FromClause = _this.RULE('FromClause', function () {
            _this.CONSUME(smsTokenMap.FROM);
            _this.OR([
                {
                    ALT: function () { return _this.SUBRULE(_this.SqlClause); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.JsonClause); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.GraphQlClause); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.CsvClause); },
                },
            ]);
        });
        _this.JsonClause = _this.RULE('JsonClause', function () {
            _this.CONSUME(smsTokenMap.Json);
            _this.CONSUME(smsTokenMap.JsonBlock);
        });
        _this.GraphQlClause = _this.RULE('GraphQlClause', function () {
            _this.CONSUME(smsTokenMap.GraphQl);
            _this.CONSUME(smsTokenMap.LCurly);
            _this.CONSUME(smsTokenMap.GraphQlBlock);
            _this.CONSUME(smsTokenMap.RCurly);
        });
        _this.SqlClause = _this.RULE('SqlClause', function () {
            _this.CONSUME(smsTokenMap.Sql);
            _this.CONSUME(smsTokenMap.LCurly);
            _this.CONSUME(smsTokenMap.SqlBlock);
            _this.CONSUME(smsTokenMap.RCurly);
        });
        _this.CsvClause = _this.RULE('CsvClause', function () {
            _this.CONSUME(smsTokenMap.Csv);
            _this.OPTION(function () {
                _this.CONSUME(smsTokenMap.LCurly);
                _this.CONSUME(smsTokenMap.RCurly);
            });
        });
        _this.ToClause = _this.RULE('ToClause', function () {
            _this.CONSUME(smsTokenMap.TO);
            _this.SUBRULE(_this.ConstructTemplate);
        });
        _this.WhereClause = _this.OVERRIDE_RULE('WhereClause', function () {
            _this.CONSUME(smsTokenMap.WHERE);
            _this.CONSUME(smsTokenMap.LCurly);
            _this.MANY(function () { return _this.SUBRULE(_this.Bind); });
            _this.CONSUME(smsTokenMap.RCurly);
        });
        _this.Bind = _this.OVERRIDE_RULE('Bind', function () {
            _this.CONSUME(smsTokenMap.BIND);
            _this.CONSUME(smsTokenMap.LParen);
            _this.SUBRULE(_this.BindExpression);
            _this.CONSUME(smsTokenMap.AS);
            _this.SUBRULE(_this.Var);
            _this.CONSUME(smsTokenMap.RParen);
        });
        _this.BindExpression = _this.RULE('BindExpression', function () {
            _this.OR([
                { ALT: function () { return _this.SUBRULE(_this.TemplateFunc); } },
                { ALT: function () { return _this.SUBRULE(_this.Expression); } },
            ]);
        });
        _this.TemplateFunc = _this.RULE('TemplateFunc', function () {
            _this.CONSUME(smsTokenMap.Template);
            _this.CONSUME(smsTokenMap.LParen);
            _this.SUBRULE(_this.String);
            _this.CONSUME(smsTokenMap.RParen);
        });
        _this.Object = _this.OVERRIDE_RULE('Object', function () {
            _this.SUBRULE(_this.GraphNode);
        });
        Parser.performSelfAnalysis(_this);
        return _this;
    }
    return SmsParser;
}(StardogSparqlParser));
export { SmsParser };
